import { createContext } from 'react';

// The static hero (staticHeroRuntime.js) paints the landing hero from
// index.html before the bundle has loaded and leaves a note of it on
// window[STATIC_HERO_GLOBAL]:
//   key       same shape as Home's heroGateKey: normalised path plus
//             ':desktop' or ':mobile'
//   ready     true once its image and fonts loaded and it became visible
//   claimed   set by React as soon as Home renders; the static hero then
//             stops revealing itself, so it can't pop up while React is
//             already rendering a gated hero of its own
//   released  set once React has taken over; later Home mounts in the same
//             page view (client-side navigation) behave normally
export const STATIC_HERO_GLOBAL = '__HIPPO_STATIC_HERO__';

const readState = (win) => {
  try {
    return win[STATIC_HERO_GLOBAL] || null;
  } catch {
    return null;
  }
};

// Whether the static hero is on screen showing exactly this hero, so React
// can take it over as it is: gate already open, no entrance animation.
export function claimStaticHero(heroGateKey, win = window) {
  const state = readState(win);
  if (!state) return false;
  state.claimed = true;
  return Boolean(state.ready && !state.released && state.key === heroGateKey);
}

export function releaseStaticHero(win = window) {
  const state = readState(win);
  if (state) state.released = true;
}

// True while Home renders the hero that replaces a visible static hero.
export const StaticHeroHandoffContext = createContext(false);
